
export const mockPosts = [
  {
    id: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    author: {
      id: 'user-001',
      nickname: 'さくらママ',
      user_type: 'user' as const,
      avatar_url: 'https://public.readdy.ai/ai/img_res/5bb9e809c3ba012fb4409814be019ef7.jpg',
    },
    category: 'つぶやき・モヤモヤ',
    title: '今日も疲れた...',
    content: '夜中に何度も起きて吸引。朝から保育園の送迎、仕事、お迎え、リハビリ...もう限界かも。でも子どもの笑顔見ると頑張れる。',
    empathy_count: 24,
    reply_count: 8,
    created_at: '2025-01-15T10:30:00Z',
  },
  {
    id: 'b2c3d4e5-f6a7-8901-bcde-f12345678901',
    author: {
      id: 'user-002',
      nickname: 'ひまわりパパ',
      user_type: 'user' as const,
      avatar_url: 'https://readdy.ai/api/search-image?query=friendly%20japanese%20father%20in%20his%20late%2030s%20kind%20smile%20portrait%20photo%20casual%20style%20warm%20lighting%20beige%20background&width=100&height=100&seq=post-avatar2&orientation=squarish',
    },
    category: '教えて！ケアの知恵',
    title: 'テープかぶれがひどくて...',
    content: '胃ろうのテープでお腹が真っ赤に。何かいい対策ありませんか？',
    empathy_count: 15,
    reply_count: 12,
    created_at: '2025-01-14T14:20:00Z',
  },
  {
    id: 'c3d4e5f6-a7b8-9012-cdef-123456789012',
    author: {
      id: 'user-003',
      nickname: 'コスモスママ',
      user_type: 'user' as const,
      avatar_url: 'https://readdy.ai/api/search-image?query=caring%20japanese%20mother%20in%20her%20mid%2030s%20gentle%20expression%20portrait%20photo%20soft%20lighting%20natural%20look%20light%20pink%20background&width=100&height=100&seq=post-avatar3&orientation=squarish',
    },
    category: '保育園・社会参加',
    title: '保育園探しで心が折れそう',
    content: '医療的ケア児を受け入れてくれる保育園が見つからない。10園以上断られました。仕事復帰したいのに...同じ経験の方いますか？',
    empathy_count: 32,
    reply_count: 15,
    created_at: '2025-01-13T09:15:00Z',
  },
  {
    id: 'd4e5f6a7-b8c9-0123-def1-234567890123',
    author: {
      id: 'partner-001',
      nickname: '田中 美咲',
      user_type: 'partner' as const,
      partner_role: '看護師',
      avatar_url: 'https://readdy.ai/api/search-image?query=professional%20japanese%20female%20nurse%20in%20her%20early%2030s%20friendly%20confident%20smile%20portrait%20photo%20medical%20uniform%20clean%20white%20background&width=100&height=100&seq=post-avatar4&orientation=squarish',
    },
    category: '教えて！ケアの知恵',
    title: '【看護師より】冬の感染症対策',
    content: '医療的ケア児の冬の感染症対策についてまとめました。加湿器の使い方、手洗いのタイミング、訪問者への対応など、ご参考にしてください。',
    empathy_count: 45,
    reply_count: 6,
    created_at: '2025-01-12T16:00:00Z',
  },
];
